<a href="https://usacycling.org">
  <img src="assets/images/usac-logo.svg" class="logo" [style.width.px]="width">
</a>